import { render } from "./Card.vue?vue&type=template&id=4387adfb"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"
script.render = render

export default script